/**
 * Utility function to check if given two items are deep equal.
 * Can be used for arrays with different lengths or elements,
 * objects, nested objects and primitives.
 */
const isDeepEqual = (inputA: any, inputB: any): boolean => {
  const deepEqual = (a: any, b: any): boolean => {
    if (a === b) return true;

    if (typeof a !== typeof b) return false;

    if (a === null || b === null) return false;

    if (typeof a !== 'object') return false;

    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) return false;

      return a.every((item, index) => deepEqual(item, b[index]));
    }

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (!Object.prototype.hasOwnProperty.call(b, key)) return false;

      if (!deepEqual(a[key], b[key])) return false;
    }

    return true;
  };

  return deepEqual(inputA, inputB);
};

export default isDeepEqual;
